module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "fm02"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "h1b",
    attrs: {
      "id": "fm02"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": " Page xvi. ",
      "epub:type": "pagebreak",
      "id": "page_xvi",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("NOTE TO READER")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Note numbers with an asterisk indicate further discussion on a topic that the reader is encouraged to peruse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Glossary contains definitions of ideas that may be unfamiliar to the reader and terms that have been used in the book in a particular way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Further Reading contains suggestions for those who wish to explore the topics of each chapter in more depth."), _c('span', {
    attrs: {
      "aria-label": " Page xvii. ",
      "epub:type": "pagebreak",
      "id": "page_xvii",
      "role": "doc-pagebreak"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4161f932","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm02.vue
// module id = 78
// module chunks = 0